import moment from "moment";

// 时间过滤
export function formatDate(value) {
  if (!value) return "/";
  return moment(value).format("YYYY-MM-DD");
}
export function formatDate1(value) {
  if (!value) return "/";
  return moment(value).format("YYYY/MM/DD");
}
export function formatSeconds(value) {
  return moment(value).format("YYYY-MM-DD HH:mm:ss");
}

export function formaHoures(value) {
  return moment(value).format("YYYY-MM-DD HH:mm");
}
export function formatDay(value) {
  return moment(value).format("YYYY-MM-DD");
}

// 金额格式化（三位逗号隔开，保留两位小数）
export function money(value) {
  if (value && value != null) {
    value = String(value);
    var left = value.split(".")[0];
    var right = value.split(".")[1];
    right = right
      ? right.length >= 2
        ? "." + right.substr(0, 2)
        : "." + right + "0"
      : ".00";
    var temp = left
      .split("")
      .reverse()
      .join("")
      .match(/(\d{1,3})/g);
    return (
      (Number(value) < 0 ? "-" : "") +
      temp
        .join(",")
        .split("")
        .reverse()
        .join("") +
      right
    );
  } else if (value === 0) {
    // 注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
    return "0.00";
  } else {
    return "";
  }
}

// 金额格式化（三位逗号隔开，保留两位小数,若小数为0，取掉）
export function moneys(value) {
  if (value && value != null) {
    value = String(value);
    var left = value.split(".")[0];
    var right = value.split(".")[1];
    right = right
      ? right.length >= 2
        ? "." + right.substr(0, 2)
        : "." + right
      : "";
    var temp = left
      .split("")
      .reverse()
      .join("")
      .match(/(\d{1,3})/g);
    return (
      (Number(value) < 0 ? "-" : "") +
      temp
        .join(",")
        .split("")
        .reverse()
        .join("") +
      right
    );
  } else if (value === 0) {
    // 注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
    return "0";
  } else {
    return "";
  }
}

export function digitUppercase(n) {
  let fraction = ["角", "分"];
  let digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
  let unit = [["元", "万", "亿"], ["", "拾", "佰", "仟"]];
  let head = n < 0 ? "欠" : "";
  n = Math.abs(n);
  let s = "";
  for (let i = 0; i < fraction.length; i++) {
    s += (
      digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]
    ).replace(/零./, "");
  }
  s = s || "整";
  n = Math.floor(n);
  for (let i = 0; i < unit[0].length && n > 0; i++) {
    let p = "";
    for (let j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p;
      n = Math.floor(n / 10);
    }
    s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
  }
  return (
    head +
    s
      .replace(/(零.)*零元/, "元")
      .replace(/(零.)+/g, "零")
      .replace(/^整$/, "零元整")
  );
}

// 格式化姓名     张**
export function formatStr(value) {
  return value.substring(0, 1) + new Array(value.length).join("*");
}

// 招标分类过滤
export function tenderType(value) {
  let name = "";
  switch (value) {
    case 1:
      name = "机械租赁";
      break;
    case 2:
      name = "劳务分包";
      break;
    case 3:
      name = "商品&材料";
      break;
    case 4:
      name = "工程分包";
      break;
    case 5:
      name = "设备租赁";
      break;
    case 6:
      name = "地质勘察";
      break;
    case 7:
      name = "设计规划";
      break;
    case 8:
      name = "专业监理";
      break;
    case 9:
      name = "造价咨询";
      break;
    case 10:
      name = "工程总包";
      break;
    case 11:
      name = "房产租赁";
      break;
    case 12:
      name = "车辆租赁";
      break;
    case 13:
      name = "PPP项目";
      break;
    case 14:
      name = "土地产权转让";
      break;
    case 15:
      name = "房产转让";
      break;
    case 16:
      name = "机械转让";
      break;
    case 17:
      name = "设备转让";
      break;
    case 18:
      name = "车辆转让";
      break;
    case 19:
      name = "物流货运";
      break;
    case 20:
      name = "其他";
      break;
    default:
      break;
  }
  return name;
}
// 招标状态
export function tenderState(value) {
  let name = "";
  switch (value) {
    case 1:
      name = "待招标";
      break;
    case 2:
      name = "招标中";
      break;
    case 3:
      name = "评标中";
      break;
    case 4:
      name = "招标结束";
      break;
    case 5:
      name = "废标";
      break;
    case 6:
      name = "入围报价";
      break;
    case 7:
      name = "流标";
      break;
    case 8:
      name = "待报名";
      break;
    case 9:
      name = "报名中";
      break;
    case 10:
      name = "资格审查中";
      break;
    default:
      break;
  }
  return name;
}
// 中标公告状态
export function noticeState(value) {
  let name = "";
  switch (value) {
    case 1:
      name = "公示中";
      break;
    case 2:
      name = "已废标";
      break;
    case 3:
      name = "已结束";
      break;
    default:
      break;
  }
  return name;
}

// 招标地址过滤

export function tenderZoingType(value) {
  let name = "";
  switch (value) {
    case 1:
    case 5:
      name = "工作地址：";
      break;
    case 3:
      name = "收货地址：";
      break;
    case 11:
    case 12:
      name = "使用地址：";
      break;
    case 14:
      name = "土地地址：";
      break;
    case 15:
      name = "房产地址：";
      break;
    case 16:
    case 17:
    case 18:
    case 20:
      name = "所在地址：";
      break;
    case 19:
      name = "发货地址：";
      break;
    default:
      name = "项目地址：";
      break;
  }
  return name;
}
// 竞价地址过滤
export function bidZoingType(value) {
  let name = "";
  switch (value) {
    case 1:
    case 5:
      name = "工作地址：";
      break;
    case 3:
      name = "收货地址：";
      break;
    case 2:
    case 4:
    case 6:
    case 7:
    case 8:
    case 9:
    case 10:
    case 13:
      name = "项目地址：";
      break;
    case 14:
      name = "土地地址：";
      break;
    case 15:
      name = "房产地址：";
      break;
    case 11:
    case 12:
      name = "使用地址：";
      break;
    case 16:
    case 17:
    case 18:
    case 20:
      name = "所在地址：";
      break;
    case 19:
      name = "发货地址：";
      break;
  }
  return name;
}
// 竞价类型过滤
export function bidType(value) {
  let name = "";
  switch (value) {
    case 1:
      name = "机械租赁";
      break;
    case 2:
      name = "劳务分包";
      break;
    case 3:
      name = "商品&材料";
      break;
    case 4:
      name = "工程分包";
      break;
    case 5:
      name = "设备租赁";
      break;
    case 6:
      name = "地质勘察";
      break;
    case 7:
      name = "设计规划";
      break;
    case 8:
      name = "专业监理";
      break;
    case 9:
      name = "造价咨询";
      break;
    case 10:
      name = "工程总包";
      break;
    case 11:
      name = "房产租赁";
      break;
    case 12:
      name = "车辆租赁";
      break;
    case 13:
      name = "PPP项目";
      break;
    case 14:
      name = "土地产权转让";
      break;
    case 15:
      name = "房产转让";
      break;
    case 16:
      name = "机械转让";
      break;
    case 17:
      name = "设备转让";
      break;
    case 18:
      name = "车辆转让";
      break;
    case 19:
      name = "物流货运";
      break;
    case 20:
      name = "其他";
      break;
    default:
      break;
  }
  return name;
}
// 竞价状态
export function competeBiddingState(value) {
  let name = "";
  switch (value) {
    case 1:
      name = "草稿";
      break;
    case 2:
      name = "竞价中";
      break;
    case 3:
      name = "已结束";
      break;
    case 4:
      name = "废标";
      break;
    case 5:
      name = "谈判中";
      break;
    default:
      break;
  }
  return name;
}
